import { Loader } from "lucide-react";

const LoaderSpinner = ({ size = 32 }: { size?: number }) => {
  return (
    <div className="flex justify-center items-center">
      <div className="relative">
        <div className="absolute inset-0 blur-xl bg-[#2462b2]/20 rounded-full animate-pulse"></div>
        <Loader className="animate-spin text-[#2462b2] relative z-10" size={size} />
      </div>
    </div>
  );
};

export default LoaderSpinner;
